import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';

const BulkActions = ({ selectedTrips, onSelectAll, onDeselectAll, onBulkDelete, onBulkArchive, onBulkDownload, totalTrips }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [actionType, setActionType] = useState('');

  const handleBulkAction = (type) => {
    if (type === 'delete') {
      setActionType('delete');
      setShowConfirmDialog(true);
    } else if (type === 'archive') {
      setActionType('archive');
      setShowConfirmDialog(true);
    } else if (type === 'download') {
      onBulkDownload(selectedTrips);
    }
  };

  const confirmAction = () => {
    if (actionType === 'delete') {
      onBulkDelete(selectedTrips);
    } else if (actionType === 'archive') {
      onBulkArchive(selectedTrips);
    }
    setShowConfirmDialog(false);
    setActionType('');
  };

  const cancelAction = () => {
    setShowConfirmDialog(false);
    setActionType('');
  };

  const isAllSelected = selectedTrips?.length === totalTrips && totalTrips > 0;
  const isSomeSelected = selectedTrips?.length > 0 && selectedTrips?.length < totalTrips;

  if (selectedTrips?.length === 0) {
    return null;
  }

  return (
    <>
      <div className="bg-primary/5 border border-primary/20 rounded-organic p-4 mb-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <Checkbox
              checked={isAllSelected}
              indeterminate={isSomeSelected}
              onChange={(e) => {
                if (e?.target?.checked) {
                  onSelectAll();
                } else {
                  onDeselectAll();
                }
              }}
              label={`${selectedTrips?.length} of ${totalTrips} trips selected`}
            />
          </div>

          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={() => handleBulkAction('download')}
            >
              Download All
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              iconName="Archive"
              iconPosition="left"
              onClick={() => handleBulkAction('archive')}
            >
              Archive
            </Button>
            
            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={() => handleBulkAction('delete')}
            >
              Delete
            </Button>
            
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onDeselectAll}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
      {/* Confirmation Dialog */}
      {showConfirmDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-card border border-border rounded-organic shadow-organic-lg max-w-md w-full p-6">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-error/10 rounded-full flex items-center justify-center mr-3">
                <Icon name="AlertTriangle" size={20} className="text-error" />
              </div>
              <h3 className="font-heading font-heading-bold text-lg text-card-foreground">
                Confirm {actionType === 'delete' ? 'Deletion' : 'Archive'}
              </h3>
            </div>
            
            <p className="font-body text-muted-foreground mb-6">
              Are you sure you want to {actionType} {selectedTrips?.length} selected trip{selectedTrips?.length > 1 ? 's' : ''}? 
              {actionType === 'delete' && ' This action cannot be undone.'}
            </p>
            
            <div className="flex items-center justify-end space-x-3">
              <Button
                variant="outline"
                onClick={cancelAction}
              >
                Cancel
              </Button>
              <Button
                variant={actionType === 'delete' ? 'destructive' : 'default'}
                onClick={confirmAction}
              >
                {actionType === 'delete' ? 'Delete' : 'Archive'} Trips
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BulkActions;